import { useParams } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import FieldworkerPlanning from "~/modules/fieldworker/components/FieldworkerPlanning";

import useUserGetById from "../api/useUserGetById";
import UserBadge from "../components/UserBadge";

export default function UserTimeOffScreen() {
    const { userId } = useParams();
    if (!userId) throw Error("No user id found");

    const { data: user } = useUserGetById(userId);

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            <GaiaPageComponent>
                {user && (
                    <UserBadge
                        profilePicture={user.profilePictureMedia?.url}
                        names={[user.firstName, user.lastName]}
                        showName
                        size={60}
                        sx={{ mt: 5, ml: 10 }}
                        nameTextVariant="h4"
                    />
                )}
                <FieldworkerPlanning userId={userId} baseUrl={`/admin/users/${userId}/timeoff`} />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
